import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/**
 * Descarga una plantilla Excel con el formato correcto para importar usuarios
 */
export const descargarPlantillaUsuarios = () => {
  // Datos de ejemplo para la plantilla
  const datosEjemplo = [
    {
      NOMBRE: '',
      APELLIDO: '',
      DNI: '',
      CORREO: ''
    }
  ];

  // Crear hoja de trabajo
  const ws = XLSX.utils.json_to_sheet(datosEjemplo);

  // Ajustar ancho de columnas
  ws['!cols'] = [
    { wch: 20 }, // NOMBRE
    { wch: 20 }, // APELLIDO
    { wch: 12 }, // DNI
    { wch: 30 }  // CORREO
  ];

  // Crear libro de trabajo
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Usuarios');

  // Generar archivo y descargar
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
  
  saveAs(data, `Plantilla_Usuarios_${new Date().toISOString().split('T')[0]}.xlsx`);
};

/**
 * Lee un archivo Excel y retorna los datos de usuarios
 * @param {File} file - Archivo Excel
 * @returns {Promise<Array>} - Array de objetos con datos de usuarios
 */
export const leerArchivoExcel = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        
        // Obtener la primera hoja
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        
        // Convertir a JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        
        // Validar y transformar datos
        const usuariosValidados = jsonData.map((row, index) => {
          const nombre = row.NOMBRE?.toString().trim();
          const apellido = row.APELLIDO?.toString().trim();
          let dni = row.DNI?.toString().trim();
          const correo = row.CORREO?.toString().trim();

          // Validaciones básicas
          if (!nombre || !apellido || !dni) {
            throw new Error(`Fila ${index + 2}: Faltan datos obligatorios (NOMBRE, APELLIDO o DNI)`);
          }

          if (!correo) {
            throw new Error(`Fila ${index + 2}: El CORREO es obligatorio`);
          }

          // Validar formato de correo
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(correo)) {
            throw new Error(`Fila ${index + 2}: El CORREO "${correo}" no es válido`);
          }

          // Truncar DNI a 8 dígitos si tiene más (acepta de 6 a 8 dígitos)
          if (dni.length > 8) {
            dni = dni.substring(0, 8);
          }

          // Validar que tenga al menos un dígito
          if (dni.length < 1) {
            throw new Error(`Fila ${index + 2}: DNI vacío`);
          }

          return {
            name: nombre.toUpperCase(),
            lastname: apellido.toUpperCase(),
            email: correo.toLowerCase(),
            dni: dni,
            password: dni, // Contraseña será el DNI
            rol: 'POSTULANTE'
          };
        });

        if (usuariosValidados.length === 0) {
          throw new Error('El archivo no contiene datos válidos');
        }

        resolve(usuariosValidados);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => {
      reject(new Error('Error al leer el archivo: ' + error));
    };

    reader.readAsArrayBuffer(file);
  });
};

/**
 * Valida que el archivo sea de tipo Excel
 * @param {File} file 
 * @returns {boolean}
 */
export const validarArchivoExcel = (file) => {
  const extensionesValidas = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-excel' // .xls
  ];
  
  return extensionesValidas.includes(file.type) || 
         file.name.endsWith('.xlsx') || 
         file.name.endsWith('.xls');
};
